type IconModel = {
  variant: 'other-vendors' | 'check' | 'chevron';
};

export const Icon = ({ variant }: IconModel) => {
  const cssClasses = `ccm-icon ccm-icon-${variant}`;
  return <em class={cssClasses}></em>;
};
